<template>
  <div class="layout" v-loading.fullscreen.lock="pageLoading"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.7)">
    <div style="position: fixed; left: 60px; top: 17px; z-index: 10000;">
      <el-button type="info" icon="el-icon-caret-left" size="small" @click="goback">返回</el-button>
    </div>
    <el-row>
      <el-col :span="5" style="height: calc(100vh - 64px); overflow: auto;">
        <div v-for="list in lists" :key="list.value" @click="getTab(list.value)" :class="{ active: pageTab === list.value, inactive: pageTab !== list.value }">{{ list.label }}</div>
      </el-col>
      <el-col :span="19" style="text-align: left; position: relative;">
        <!-- 設定無法收到驗證碼的登記連結 -->
        <div v-if="pageTab === '1'" style="padding: 10px;">
          <el-row :gutter="10">
            <el-col :span="17">
              <div style="border: 1px solid #888; border-radius: 5px; padding: 15px;">
                <el-row :gutter="10">
                  <el-col :span="4">
                    <div class="title">登記連結</div>
                  </el-col>
                  <el-col :span="15">
                    <el-input v-model="notReceivedLink"></el-input>
                  </el-col>
                  <el-col :span="5">
                    <el-button type="danger" style="width: 100%;" :disabled="!notReceivedLink" @click="sendSheet">送出</el-button>
                  </el-col>
                </el-row>
                <div style="margin-top: 10px; padding-left: 2px; margin-bottom: 20px;">
                  <div>連結格式參考：</div>
                  <div style="word-wrap: break-word;">https://docs.google.com/forms/d/e/1FAIpQLSffXEmh4QwNBmUdmXIBjQ-ACW4UntdCM7NaXHQsqdaAhjRyW1/viewform</div>
                </div>
                <el-row :gutter="10">
                  <el-col :span="4">
                    <div class="title">注意事項</div>
                  </el-col>
                  <el-col :span="9">
                    <h3 style="word-wrap: break-word; margin-bottom: 2px; margin-top: 0;">1.連結請設定 google 表單連結</h3>
                    <div style="word-wrap: break-word; font-size: 16px;">目的是為了搜集消費者的註冊資料</div>
                    <h3 style="margin-bottom: 10px;">2.表單必備的資料欄位：</h3>
                    <div style="margin-top: 5px; color: #555; font-weight: 500;">
                      <div class="indexCircle">1</div>
                      <div style="font-size: 16px; display: inline-block; margin-left: 10px; line-height: 20px;">註冊行動電話</div>
                    </div>
                    <div style="margin-top: 5px; color: #555; font-weight: 500;">
                      <div class="indexCircle">2</div>
                      <div style="font-size: 16px; display: inline-block; margin-left: 10px; line-height: 20px;">姓名</div>
                    </div>
                    <div style="margin-top: 5px; color: #555; font-weight: 500;">
                      <div class="indexCircle">3</div>
                      <div style="font-size: 16px; display: inline-block; margin-left: 10px; line-height: 20px;">出生年月日(西元)</div>
                    </div>
                    <div style="margin-top: 5px; color: #555; font-weight: 500;">
                      <div class="indexCircle">4</div>
                      <div style="font-size: 16px; display: inline-block; margin-left: 10px; line-height: 20px;">Email</div>
                    </div>
                  </el-col>
                  <el-col :span="11">
                    <img src="./sheet_demo.png" width="95%"/>
                  </el-col>
                </el-row>
              </div>
            </el-col>
            <el-col :span="7">
              <div style="border: 1px solid #888; border-radius: 5px; padding: 20px;">
                <h3 style="text-align: center; margin-top: 5px; color: #666;">
                  <div style="margin-bottom: 10px;">使用方式</div>
                  <div>當消費者點擊</div>
                  <div>『我知道了』的按鈕時</div>
                  <div>會連結至表單連結</div>
                </h3>
                <div style="text-align: center; margin-top: 30px;">
                  <img src="./demo.png" width="90%"/>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <!-- 產生註冊連結 -->
        <div v-if="pageTab === '2'" style="padding: 20px;">
          <el-row :gutter="10">
            <el-col :span="4">
              <div class="title">使用說明</div>
            </el-col>
            <el-col :span="20">
              <div class="infoBox">
                <div>如果遇到消費者反應，一直收不到簡訊驗證碼，可以人工產生註冊連結，系統會自動將連結推播給消費者。</div><br>
                <div style="color: #982734;">
                  <img src="./warning.png" width="17" style="transform: translateY(2px)"/>
                  請注意：消費者如使用該連結註冊，會「省略驗證行動電話的步驟」
                </div>
                <div>
                  因電話未經過驗證，可能會有電話為無效號碼，或是消費者冒用他人資料等風險。<br>
                  請確實向消費者確認註冊資料，以及說明相關責任，且操作人員也需要小心使用!<br><br>
                  備註：消費者嘗試多次仍收不到驗證碼，有以下可能:<br> 
                  1.行動電話號碼輸入錯誤、2.國碼輸入錯誤、3.手機安裝阻擋簡訊軟體。
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="10" style="margin-top: 10px;">
            <el-col :span="4">
              <div class="title">
                Step 1<br>查詢及輸入<br>消費者<br>註冊資料
              </div>
            </el-col>
            <el-col :span="20">
              <div class="infoBox" style="background-color: #fff;">
                <el-row>
                  <el-col :span="19">
                    <div>
                      <div style="width: 100px; display: inline-block;">行動電話：</div>
                      <el-input placeholder="例：0912345678"
                        style="width: 45%; margin-right: 10px;"
                        v-model.trim="user.phone">
                      </el-input>
                      <el-button type="primary" @click="queryUser" :disabled="!user.phone" :loading="isLoading">查詢</el-button>
                      <i class="el-icon-success" v-if="isUser" style="margin-left: 10px; font-size: 20px; color: #53c24c"></i>
                    </div>
                    <div style="margin-top: 15px;" v-if="isUser">
                      <div style="width: 100px; display: inline-block;">姓名：</div>
                      <el-input placeholder="例：林芝靈"
                        style="width: 45%; margin-right: 10px;"
                        v-model="user.name">
                      </el-input>
                    </div>
                    <div style="margin-top: 15px;" v-if="isUser">
                      <div style="width: 100px; display: inline-block;">Email：</div>
                      <el-input placeholder="例：example@eilis-ai.com"
                        style="width: 45%; margin-right: 10px;"
                        v-model.trim="user.email">
                      </el-input>
                    </div>
                    <div style="margin-top: 15px;" v-if="isUser">
                      <div style="width: 100px; display: inline-block;">生日 (8碼)：</div>
                      <el-input placeholder="例：19951003"
                        style="width: 45%; margin-right: 10px;"
                        v-model.trim="user.birth">
                      </el-input>
                    </div>
                  </el-col>
                  <!-- 手機 -->
                  <el-col :span="5" style="text-align: center;">
                    <img src="./demo.png" width="90%"/>
                    <div style="font-size: 13px; margin-top: 10px;">▲ 消費者點擊「我知道了」的按鈕才可以查詢該名消費者電話。</div>
                  </el-col>
                </el-row>
              </div>
            </el-col>
          </el-row>
          <!-- 步驟二 -->
          <el-row :gutter="10" style="margin-top: 10px;">
            <el-col :span="4">
              <div class="title">
                Step 2<br>將註冊連結<br>推播給消費者
              </div>
            </el-col>
            <el-col :span="20">
              <div class="infoBox" style="background-color: #fff;">
                <div style="margin-bottom: 5px;">
                  <img src="./warning.png" width="17" style="transform: translateY(2px)"/>
                  請確認消費者註冊資料是否有輸入正確喔!
                </div>
                <el-button type="danger" style="width: 100%;" :disabled="!checkValue" @click="sendBroadcast">確認無誤，點擊這裡發送推播</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
        <!-- 修改單一會員資料 -->
        <div v-if="pageTab === '3'" style="padding: 20px;">
          <div>
            <span style="color: black; font-size: 15px;">會員電話：</span>
            <el-input placeholder="請輸入會員電話"
              style="width: 40%; margin-left: 10px;"
              prefix-icon="el-icon-search"
              v-model="searchPhone">
            </el-input>
            <el-button type="danger" :loading="isLoading" :disabled="!searchPhone" style="margin-left: 10px;" @click="queryMember">查詢</el-button>
          </div>
          <div style="margin-top: 20px;">
            <el-radio-group v-model="radio1" fill="#777">
              <el-radio-button label="基本資料" :disabled="!isUser"></el-radio-button>
              <el-radio-button label="更改電話" :disabled="!isUser"></el-radio-button>
              <el-radio-button label="更改 LINE ID" v-if="service === 'LINE'" :disabled="!isUser"></el-radio-button>
              <el-radio-button label="更改 FB ID" v-if="service === 'FB'" :disabled="!isUser"></el-radio-button>
            </el-radio-group>
          </div>
          <!-- 修改 LINE ID -->
          <div class="userBox2" v-if="radio1 === '更改 LINE ID' || radio1 === '更改 FB ID'">
            <div style="color: #f24; margin-bottom: 10px;">注意：修改會員 {{ service }} ID 的情況，一般都是在「會員更換 {{ service }} 帳號」才需要做更改。</div>
            <div style="margin-bottom: 10px;">修改時請留意新舊 ID 是否屬於該會員，以免影響會員帳號使用。</div>
            <div>
              <span style="color: black; font-size: 15px;">原 {{ service }} ID：</span>
              <el-input style="width: 50%; margin-left: 10px;"
                disabled
                v-model.trim="user.token">
              </el-input>
            </div>
            <div style="margin-top: 20px;">
              <span style="color: black; font-size: 15px;">新 {{ service }} ID：</span>
              <el-input style="width: 50%; margin-left: 10px;"
                v-model.trim="newToken">
              </el-input>
            </div>
          </div>
          <!-- 修改電話 -->
          <div class="userBox2" v-if="radio1 === '更改電話'">
            <div style="color: #f24; margin-bottom: 10px;">注意：電話修改後，會員登入時需重新驗證電話</div>
            <div>
              <span style="color: black; font-size: 15px;">原電話：</span>
              <el-input style="width: 40%; margin-left: 10px;"
                disabled
                v-model.trim="user.phone">
              </el-input>
            </div>
            <div style="margin-top: 20px;">
              <span style="color: black; font-size: 15px;">新電話：</span>
              <el-input style="width: 40%; margin-left: 10px;"
                v-model.trim="newPhone">
              </el-input>
            </div>
          </div>
          <!-- 基本資料 -->
          <div class="userBox" v-if="radio1 === '基本資料'">
            <el-row>
              <el-col :span="5">
                <h3 style="text-align: left; margin: 0;">姓名</h3>
              </el-col>
              <el-col :span="14">
                <h3 style="text-align: left; margin: 0;"><span style="color: #409EFF;">{{ user.name ? user.name : '-' }}</span></h3>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="5">
                <h3 style="text-align: left; margin-bottom: 0;">生日</h3>
              </el-col>
              <el-col :span="14">
                <h3 style="text-align: left; margin-bottom: 0;"><span style="color: #409EFF;">{{ user.birth ? user.birth : '-' }}</span></h3>
              </el-col>
              <el-col :span="5">
                <div style="text-align: right;">
                  <el-button type="info" icon="el-icon-edit" size="small" @click="editInfoDia = true"></el-button>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="5">
                <h3 style="text-align: left; margin-bottom: 10px;">Email</h3>
              </el-col>
              <el-col :span="14">
                <h3 style="text-align: left; margin-bottom: 10px;"><span style="color: #409EFF;">{{ user.email ? user.email : '-' }}</span></h3>
              </el-col>
            </el-row>
            <hr/>
            <el-row>
              <el-col :span="5">
                <h3 style="text-align: left;">電話</h3>
              </el-col>
              <el-col :span="14">
                <h3 style="text-align: left;"><span style="color: #409EFF;">{{ user.phone ? user.phone : '-' }}</span></h3>
              </el-col>
              <!-- <el-col :span="5">
                <div style="text-align: right; padding-top: 12px;">
                  <el-button type="info" icon="el-icon-edit" size="small" @click="editPhoneDia = true"></el-button>
                </div>
              </el-col> -->
            </el-row>
            <hr/>
            <el-row>
              <el-col :span="5">
                <h3 style="text-align: left; margin-bottom: 0px;">點數</h3>
              </el-col>
              <el-col :span="14">
                <h3 style="text-align: left; margin-bottom: 0px;"><span style="color: #409EFF;">{{ user.point ? user.point : '-' }}</span></h3>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="5">
                <h3 style="text-align: left; margin-bottom: 0px;">經驗值</h3>
              </el-col>
              <el-col :span="14">
                <h3 style="text-align: left; margin-bottom: 0px;"><span style="color: #409EFF;">{{ user.exp ? user.exp : '-' }}</span></h3>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="5">
                <h3 style="text-align: left; margin-bottom: 0px;">註冊時間</h3>
              </el-col>
              <el-col :span="14">
                <h3 style="text-align: left; margin-bottom: 0px;"><span style="color: #409EFF;">{{ user.addTime ? new Date(user.addTime).toISOString() : '-' }}</span></h3>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="5">
                <h3 style="text-align: left; margin-bottom: 0px;">資料更新時間</h3>
              </el-col>
              <el-col :span="14">
                <h3 style="text-align: left; margin-bottom: 0px;"><span style="color: #409EFF;">{{ user.updateTime ? new Date(user.updateTime).toISOString() : '-' }}</span></h3>
              </el-col>
            </el-row>
          </div>
          <el-button v-if="radio1 === '基本資料'" style="width: 100%; margin-top: 15px;" type="warning" @click="sendUpdate">儲存變更</el-button>
          <el-button v-if="radio1 === '更改電話'" :disabled="!newPhone" style="width: 100%; margin-top: 15px;" type="warning" @click="changePhone">儲存變更</el-button>
          <el-button v-if="radio1 === '更改 LINE ID' || radio1 === '更改 FB ID'" :disabled="!newToken" style="width: 100%; margin-top: 15px;" type="warning" @click="changeToken">儲存變更</el-button>
        </div>
      </el-col>
    </el-row>
    <mu-dialog :open="editInfoDia" title="編輯基本資料" width="450">
      <mu-text-field v-model.trim="user.name" label="姓名" full-width></mu-text-field><br/>
      <mu-text-field v-model.trim="user.birth" label="生日" :error-text="errorBirth" full-width></mu-text-field><br/>
      <mu-text-field v-model.trim="user.email" label="Email" full-width></mu-text-field><br/>
      <mu-button slot="actions" color="primary" @click="closeEditDialog">完成</mu-button>
    </mu-dialog>
    <mu-dialog :open.sync="errorDia" width="450">
      {{ errorMsg }}
    </mu-dialog>
    <div style="position: fixed; bottom: 10px; left: 20px; text-align: left;">
      <img src="https://i.imgur.com/SITKieL.png" width="120"/>
      <div style="padding-left: 12px; font-size: 13px;">Copyright © 2020 埃立思科技股份有限公司 版權所有</div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      service: this.$route.params.service,
      auth: this.$route.params.id,
      lists: [
        { value: '1', label: '設定無法收到驗證碼的登記連結' },
        { value: '2', label: '產生註冊連結（跳過驗證電話）' },
        { value: '3', label: '修改單一會員資料' }
      ],
      // lists: ['設定無法收到驗證碼的登記連結', '產生註冊連結（跳過驗證電話）'],
      pageTab: '1',
      notReceivedLink: '',
      noVerLink: '',
      user: {
        service: this.$route.params.service,
        auth: this.$route.params.id,
        token: '',
        phone: '',
        name: '',
        email: '',
        birth: '',
        group: 0,
        point: '',
        updateTime: '',
        addTime: '',
        exp: ''
      },
      errorBirth: '',
      searchPhone: '',
      isUser: false,
      pageLoading: false,
      errorDia: false,
      radio1: '',
      errorMsg: '',
      newPhone: '',
      newToken: '',
      editPhoneDia: false,
      editInfoDia: false,
      isLoading: false
    }
  },
  mounted() {
    this.getAccountData();
  },
  computed: {
    checkValue() {
      if (this.user.phone && this.user.name && this.user.birth && this.isUser) {
        return true;
      }
      return false;
    }
  },
  methods: {
    ...mapActions({
      saveNotReceivedLink: 'saveNotReceivedLink',
      getNotReceivedToken: 'getNotReceivedToken',
      saveUserDetailToReceiver: 'saveUserDetailToReceiver',
      checkAccount: 'checkAccount',
      FBUserBroadcast: 'FBUserBroadcast',
      getUserByPhone: 'getUserByPhone',
      updateUserDetail: 'updateUserDetail',
      changeUserToken: 'changeUserToken',
      changeUserPhone: 'changeUserPhone',
      lineUserBroadcast: 'lineUserBroadcast'
    }),
    showNotify(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      });
    },
    closeEditDialog() {
      const regPos = /^[0-9]+.?[0-9]*/;
      if (this.user.birth.length !== 8 || !regPos.test(this.user.birth)) {
        this.errorBirth = '生日格式錯誤，參考範例：19950610';
      }
      else {
        this.errorBirth = '';
        this.editInfoDia = false;
      }
    },
    changeToken() {
      this.pageLoading = true;
      const postData = {
        service: this.service,
        auth: this.auth,
        oldToken: this.user.token,
        newToken: this.newToken
      };
      this.changeUserToken(postData).then(() => {
        this.pageLoading = false;
        this.newToken = '';
        this.queryMember();
        this.radio1 = '基本資料';
      })
    },
    changePhone() {
      this.pageLoading = true;
      const postData = {
        service: this.service,
        auth: this.auth,
        originPhone: this.user.phone,
        newPhone: this.newPhone,
        status: '未驗證'
      };
      this.changeUserPhone(postData).then((res) => {
        this.pageLoading = false;
        if (res.data.Message === '已更新電話') {
          this.queryMember();
          this.newPhone = '';
          this.radio1 = '基本資料';
          this.showNotify('更新會員電話成功', '', 'success');
        }
        else {
          this.showNotify(res.data.Message, '', 'error');
        }
      })
    },
    sendUpdate() {
      const updateData = {
        Email: this.user.email,
        Name: this.user.name,
        ID: this.user.birth,
        updateTime: Date.now()
      };
      const postData = {
        service: this.service,
        auth: this.auth,
        group: this.user.group,
        token: this.user.token,
        updateData: updateData
      };
      this.updateUserDetail(postData).then(() => {
        this.queryMember();
      })
      this.showNotify('更新成功', '', 'success');
    },
    queryMember() {
      this.isLoading = true;
      const postData = {
        service: this.service, auth: this.auth, phone: this.searchPhone
      };
      this.getUserByPhone(postData).then((res) => {
        this.isLoading = false;
        if (res.data.id) {
          this.isUser = true;
          this.radio1 = '基本資料';
          this.user.token = res.data.id;
          this.user.phone = res.data.Phone;
          this.user.name = res.data.Name ? res.data.Name : '';
          this.user.email = (res.data.Email && res.data.Email !== '無資料') ? res.data.Email : '';
          this.user.birth = res.data.ID ? res.data.ID : '';
          this.user.group = res.data.Group ? res.data.Group : 0;
          this.user.point = res.data.Point ? res.data.Point : 0;
          this.user.exp = res.data.EXP ? res.data.EXP : 0;
          this.user.addTime = res.data.AddTime ? res.data.AddTime : '';
          this.user.updateTime = res.data.updateTime ? res.data.updateTime : '';
        }
        else {
          this.isUser = false;
          this.user.token = '';
          this.user.phone = '';
          this.user.name = '';
          this.user.email = '';
          this.user.birth = '';
          this.user.group = 0;
          this.user.point = '';
          this.user.exp = '';
          this.user.addTime = '';
          this.user.updateTime = '';
          this.showNotify('查無此會員', '', 'error');
        }
      })
    },
    getAccountData() {
      this.checkAccount({ Service: this.service, Auth: this.auth })
        .then((res) => {
          this.notReceivedLink = res.notReceivedLink;
          this.noVerLink = res.noVerLink;
          // console.log(this.notReceivedLink);
          // console.log(this.noVerLink);
        })
    },
    sendSheet() {
      const postData = {
        service: this.service,
        auth: this.auth,
        url: this.notReceivedLink
      };
      this.saveNotReceivedLink(postData).then(() => {
        this.getAccountData();
      })
      this.$notify.success({
        title: '設定成功'
      });
    },
    goback() {
      this.$router.push(`/shoplist/?service=${this.service}&auth=${this.auth}`);
    },
    getTab(val) {
      this.pageTab = val;
    },
    sendBroadcast() {
      // 發送前檢查生日
      var reg = /^[\d]+$/;
      if (reg.test(this.user.birth)) {
        if (this.user.birth.length === 8) {
          if (!this.notReceivedLink) {
            this.errorDia = true;
            this.errorMsg = '尚未設定驗證碼的登記連結';
          }
          else {
            const loading = this.$loading({ lock: true, text: 'Loading', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' });
            if (this.service === 'LINE') {
              const postData = {
                channelId: this.auth,
                uuId: this.user.token,
                message: '親愛的顧客您好\n\n我們收到您反應的註冊問題\n已經為您產生專屬註冊連結\n\n請於 24 小時內點擊下方按鈕\n儘速完成註冊手續\n以確保您的會員使用權益\n\n感謝您的耐心等候，謝謝您:)',
                btnLabel: '前往註冊會員',
                directUrl: this.noVerLink
              };
              this.lineUserBroadcast(postData)
                .then(() => {
                  loading.close();
                  this.$notify.success({
                    title: '已送出廣播'
                  });
                })
            }
            else {
              const postData = {
                pageID: this.auth,
                psID: this.user.token,
                message: '親愛的顧客您好\n\n我們收到您反應的註冊問題\n已經為您產生專屬註冊連結\n\n請於 24 小時內點擊下方按鈕\n儘速完成註冊手續\n以確保您的會員使用權益\n\n感謝您的耐心等候，謝謝您:)',
                btnLabel: '前往註冊會員',
                directUrl: this.noVerLink
              };
              this.FBUserBroadcast(postData)
                .then(() => {
                  loading.close();
                  this.$notify.success({
                    title: '已送出廣播'
                  });
                })
            }
            this.saveUserDetailToReceiver(this.user);
          }
        }
        else {
          this.errorDia = true;
          this.errorMsg = '生日格式錯誤！請填寫 8 碼數字，如：19951003';
        }
      }
      else {
        this.errorDia = true;
        this.errorMsg = '生日格式錯誤！請填寫 8 碼數字，如：19951003';
      }
    },
    queryUser() {
      this.isUser = false;
      this.isLoading = true;
      const postData = {
        service: this.service, auth: this.auth, phone: this.user.phone
      };
      this.getNotReceivedToken(postData).then((res) => {
        this.isLoading = false;
        if (res.data.Token) {
          this.isUser = true;
          this.user.token = res.data.Token;
        }
        else {
          this.errorDia = true;
          this.errorMsg = '查無此會員';
        }
      })
    }
  }
}
</script>

<style scoped>
.layout {
  min-width: 100%;
  max-width: 100%;
  padding-top: 60px;
  margin-left: 0!important;
  flex: 1 1 100%;
}
.layout-66 {
  border-radius: 6px;
  background: #ffffff;
  height: 500px;
  min-width: 66.6666%;
  max-width: 66.6666%;
  flex: 0 1 66.6666%;
}
.userBox {
  padding: 30px;
  margin-top: 15px;
  border: 1px solid #777;
  border-radius: 5px;
  overflow: auto;
  max-height: 420px;
  height: calc(100vh - 380px);
}
.userBox2 {
  padding: 30px;
  margin-top: 15px;
  border: 1px solid #777;
  border-radius: 5px;
}
.active {
  padding: 20px 20px;
  color: #fff;
  font-size: 16px;
  width: 100%;
  font-weight: 600;
  border-bottom: 1px solid #fff;
  background-color: #079feb;
  cursor: pointer;
}
.inactive:hover {
  background-color: #079feb;
}
.inactive {
  padding: 20px 20px;
  width: 100%;
  font-size: 16px;
  color: #fff;
  font-weight: 600;
  border-bottom: 1px solid #fff;
  background-color: #4ec1f2;
  cursor: pointer;
}
.card {
  border-radius: 3px;
  background-color: #999;
  padding: 15px;
  margin-top: -20px;
  margin-right: 15px;
  float: left;
}
.title {
  background-color: #999;
  text-align: center;
  padding: 8px;
  color: #fff;
  font-size: 16px;
  border-radius: 5px;
  font-weight: 600;
}
.layout-33 {
  height: 500px;
  background: #ffffff;
  min-width: 100px;
  max-width: 400px;
  flex: 0 1 33.3333%;
}
.indexCircle {
  width: 18px;
  height: 18px;
  transform: translateY(-1px);
  text-align: center;
  display: inline-block;
  line-height: 15px;
  color: #555;
  border: 1px solid #888;
  border-radius: 50%;
}
.infoBox {
  background-color: #ededed;
  font-weight: 500;
  font-size: 16px;
  color: #555;
  border: 1px solid #888;
  padding: 10px;
  border-radius: 5px;
}

</style>